import React from "react";
import Card from "../../../../Utilities/Card";
import { severityOf } from "../../../../../Utils/severity";
import { withInlineCode } from "../../../../../Utils/inlineCode";

const Component = ({ cve, cvss, details, link }) => {
  const severity = severityOf(cvss);

  return (
    <Card
      to={link || ""}
      title={cve}
      badges={severity !== "" && <span className={`badge ${severity.toLowerCase()}`}>{`CVSS ${cvss} · ${severity}`}</span>}
      description={withInlineCode(details)}
    />
  )
}

export default Component
